import React from 'react';

import { Loader } from 'features/order-tracker/shared-components/LoadingIndicator/components/Loader';

import {
  LOADING_MODAL_MESSAGE,
  LOADING_AFTER_AMENDING_MODAL_TITLE,
  LOADING_MODAL_TITLE,
} from './constants';

import styles from './styles.module.scss';

export const LoadingModal: React.FC<sharedComponents.LoadingModal> = ({ isAfterAmending }) => (
  <div className={styles.loadingContent}>
    <h4>{isAfterAmending ? LOADING_AFTER_AMENDING_MODAL_TITLE : LOADING_MODAL_TITLE}</h4>
    <p>{LOADING_MODAL_MESSAGE}</p>
    <div className={styles.loaderContainer}>
      <Loader />
    </div>
  </div>
);
